// FNP-1193 — the certificate write path (FNP-1221's two mutations).
//
// ⚠️ THERE IS NO `updateCertificate`, AND THAT IS THE SCHEMA'S DESIGN.
//
// A certificate is IMMUTABLE once issued. The write surface is request and
// delete, and changing a certificate means requesting a new one. Nothing in
// this module may offer an edit affordance — there is no mutation behind it.

// ⚠️ THE FULL CERTIFICATE COMES BACK, INCLUDING ITS VALIDATION RECORDS.
//
// A freshly requested certificate is PENDING_VALIDATION with the records the
// provider wants published, and Flexi has just written them through the owning
// zone's adapter. Selecting them means the operator sees what was written
// immediately — which is the hand-copying step this module exists to remove,
// and the thing they will want to compare against the zone if it never settles.
//
// `validationRecordWrittenAt` is selected for the same reason it is on the read
// path: its nullness is what separates VALIDATION_NOT_WRITTEN from STUCK, so a
// request that issued the certificate but failed to write the record is
// visible as that, immediately, rather than after a 30-minute threshold.
export const requestCertificate = `
    mutation requestCertificate($input: RequestCertificateInput!) {
        requestCertificate(input: $input) {
            id
            accountId
            connectionId
            domainName
            coveredNames
            targetType
            region
            status
            statusDetail
            expirationDate
            validationRecords {
                name
                type
                value
                domainName
                status
            }
            validationRecordWrittenAt
            validationZoneId
            stuckAfterMinutes
            issuingAwsAccountId
            createdByUsername
            created
            updated
        }
    }
`;

// ⚠️ EVERY FIELD OF THE RESULT IS SELECTED, AND `inUse` IS THE POINT.
//
// The provider — not Flexi — decides whether a certificate may be deleted, and
// ACM refuses to delete one serving a live distribution. That refusal is
// USEFUL: the certificate is serving something, and deleting it would take a
// site offline.
//
// `inUse` separates that refusal from every other failure so the console can
// say "this certificate is serving something" rather than "something went
// wrong". Those have completely different fixes, and a caller that selected
// only `deleted` would flatten them back into one.
//
// `localRecordDeleted` is selected because a refusal LEAVES THE LOCAL ROW. The
// certificate is still there and still listed, and a console that removed the
// row optimistically would show it vanishing from a delete that did not happen.
export const deleteCertificate = `
    mutation deleteCertificate($input: DeleteCertificateInput!) {
        deleteCertificate(input: $input) {
            id
            connectionId
            deleted
            inUse
            reason
            localRecordDeleted
        }
    }
`;
